module.exports = __webpack_public_path__ + "fonts/nunito-light.a261e36.woff";